import { Grid, Stack } from '@mui/material';

import { NoSearchResults } from '@hapvida/hapvida-core-components';

import { ServiceItem } from '../ServiceItem';
import { useMovementMenuOptions } from '../../hooks';

export function FilteredServices() {
  const { filteredServices } = useMovementMenuOptions();

  const isEmptyResult = filteredServices.length === 0;

  return (
    <Stack p={3} gap={3}>
      {isEmptyResult ? (
        <NoSearchResults padding={5} />
      ) : (
        <Grid container spacing={2}>
          {filteredServices.map(item => (
            <Grid item xs={6} key={item.title}>
              <ServiceItem
                primary={item.primary}
                title={item.title}
                icon={item.icon}
                description={item.description}
                redirects={item.redirects}
                type={item.type}
              />
            </Grid>
          ))}
        </Grid>
      )}
    </Stack>
  );
}
